import React from "react";
import { Box, Grid, Typography, Link, Divider } from "@mui/material";

function FooterData() {
  return (
    <Box width="100%" bgcolor="#233F91" color="#FFFFFF" py={4}>
      <Grid container spacing={2} py={2} alignItems="center">
        {/* Logo Section */}
        <Grid
          item
          xs={12}
          md={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            component="img"
            src="/assets/icons/affectiLogoWhite.svg" // Replace with the actual logo path
            alt="Affekti Logo"
            sx={{ width: "161px", height: "76px" }}
          />
        </Grid>

        {/* Links Section */}
        <Grid item xs={12} md={8} display="flex" justifyContent="center">
          <Box display="flex" gap={4} flexWrap="wrap" justifyContent="center">
            <Link
              href="https://www.chopdawgwp.com/Affekti/#about"
              color="inherit"
              underline="none"
              sx={{ fontSize: "16px", fontWeight: 600 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              About
            </Link>
            <Link
              href="https://www.chopdawgwp.com/Affekti/blog/"
              color="inherit"
              underline="none"
              sx={{ fontSize: "16px", fontWeight: 600 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Blog & Latest News
            </Link>
            <Link
              href="https://www.chopdawgwp.com/Affekti/faq/"
              color="inherit"
              underline="none"
              sx={{ fontSize: "16px", fontWeight: 600 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              FAQ's
            </Link>
            <Link
              href="https://www.chopdawgwp.com/Affekti/#contactus"
              color="inherit"
              underline="none"
              sx={{ fontSize: "16px", fontWeight: 600 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us
            </Link>
            <Link
              href="/content-creator"
              color="inherit"
              underline="none"
              sx={{ fontSize: "16px", fontWeight: 600 }}
            >
              Become a Content Creator
            </Link>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Divider
          sx={{
            my: 4,
            // width: "1212px",
            width: "90%",
            height: "1px",
            bgcolor: "#F9ED32",
          }}
        />
      </Box>
      {/* Footer Bottom Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        textAlign="center"
        mt={2}
        py={2}
      >
        <Typography
          sx={{ color: "#EDEDED", fontSize: "14px", fontWeight: 400 }}
        >
          © 2025 Affekti. All rights reserved.
        </Typography>
        <Box display="flex" justifyContent="center" gap={2}>

          <Link
            href="https://www.chopdawgwp.com/Affekti/privacy-policy/"
            color="inherit"
            underline="none"
            sx={{ color: "#EDEDED", fontSize: "14px", fontWeight: 400 }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>

          <Link
            href="https://www.chopdawgwp.com/Affekti/terms-of-service/"
            color="inherit"
            underline="none"
            sx={{ color: "#EDEDED", fontSize: "14px", fontWeight: 400 }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default FooterData;
